"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogComposer = void 0;
var React = __importStar(require("react"));
var DialogLayoutSide_1 = require("./layout/DialogLayoutSide");
var SideDialog_1 = require("../SideDialog");
var styles_1 = require("@material-ui/core/styles");
var Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
var DialogLayoutCentered_1 = require("./layout/DialogLayoutCentered");
var styles = styles_1.createStyles({});
exports.DialogComposer = styles_1.withStyles(styles, { name: "EuiDialogLayout" })(React.forwardRef(function DialogComposer(_a, ref) {
    var _b = _a.variant, variant = _b === void 0 ? "dialog" : _b, anchor = _a.anchor, dialogTitle = _a.dialogTitle, DialogTitleProps = _a.DialogTitleProps, onClickReturn = _a.onClickReturn, ReturnButtonProps = _a.ReturnButtonProps, onClose = _a.onClose, displayClose = _a.displayClose, onClickClose = _a.onClickClose, CloseButtonProps = _a.CloseButtonProps, children = _a.children, DialogContentProps = _a.DialogContentProps, dialogActions = _a.dialogActions, DialogActionsProps = _a.DialogActionsProps, TitleTypographyProps = _a.TitleTypographyProps, props = __rest(_a, ["variant", "anchor", "dialogTitle", "DialogTitleProps", "onClickReturn", "ReturnButtonProps", "onClose", "displayClose", "onClickClose", "CloseButtonProps", "children", "DialogContentProps", "dialogActions", "DialogActionsProps", "TitleTypographyProps"]);
    var Component = variant === "sideDialog" ? SideDialog_1.SideDialog : Dialog_1.default;
    var renderLayout = function () {
        var baseProps = {
            dialogTitle: dialogTitle,
            DialogTitleProps: DialogTitleProps,
            onClose: onClose,
            displayClose: displayClose,
            onClickClose: onClickClose,
            CloseButtonProps: CloseButtonProps,
            children: children,
            DialogContentProps: DialogContentProps,
            dialogActions: dialogActions,
            DialogActionsProps: DialogActionsProps,
            TitleTypographyProps: TitleTypographyProps,
        };
        switch (variant) {
            case "dialog":
                return React.createElement(DialogLayoutCentered_1.DialogLayoutCentered, __assign({}, baseProps));
            case "sideDialog":
                return (React.createElement(DialogLayoutSide_1.DialogLayoutSide, __assign({}, baseProps, { onClickReturn: onClickReturn, ReturnButtonProps: ReturnButtonProps })));
            default:
                return children;
        }
    };
    return (React.createElement(Component, __assign({ anchor: variant === "sideDialog" ? anchor : undefined, onClose: onClose }, props, { ref: ref }), renderLayout()));
}));
//# sourceMappingURL=DialogComposer.js.map